'use strict';

function crossfilter_zero() {
  return 0;
}

module.exports = crossfilter_zero;
